export const DEFAULT_COLUMN_BUFFER: number = 20;
export const DEFAULT_ROW_BUFFER: number = 10;

export const BUFFER_STAGES = [
    { columnBuffer: 3, rowBuffer: 3, delay: 0 },
    { columnBuffer: 10, rowBuffer: 8, delay: 150 },
    { columnBuffer: 20, rowBuffer: 15, delay: 400 },
];

export const SCROLL_LOCK_DURATION = 50;

export enum ScrollSource {
    Main = 'main',
    FrozenCols = 'frozenCols',
    FrozenRows = 'frozenRows',
}


export const VISIBILITY_THRESHOLD: number = 0.7;